@if (offer?.amenities; as amenities) {
  <div
    #iconRow
    class="icon-row"
    [class.icon-row--tiles]="viewMode === 'tiles'"
    [class.icon-row--list]="viewMode === 'list'">
    @for (icon of activeIcons(amenities); track icon;  let i = $index) {
      <div #iconChip class="icon-chip">
        <img class="icon" [src]="iconSrc(icon.svg_name)" alt="{{ icon.alt_alias }}" />
        &nbsp;<span class="label">{{ icon.display_name | titlecase }}</span>
      </div>
    }
  </div>
  <!-- Render tags on a separate line below the icons as pill chips -->
  @if (amenities.tags && amenities.tags.length > 0) {
    <div
      #tagRow
      class="tag-row"
      [class.tag-row--tiles]="viewMode === 'tiles'"
      [class.tag-row--list]="viewMode === 'list'">
      @for (tag of amenities.tags; track tag; let ti = $index) {
        <span #tagChip class="tag-chip">{{ tag | titlecase }}</span>
      }
    </div>
  } 
}